module.exports = "<button class=\"toggle\" ng-click=\"$ctrl.open = !$ctrl.open\"></button>\n<ul ng-class=\"{'open': $ctrl.open, 'arabDirection':  $ctrl.I18n.isArLocale()}\">\n  <li ng-repeat=\"type in $ctrl.types track by type.id\" >\n    <a role=\"tab\"\n       ui-sref=\"vehicle.catalog.{{type.id}}()\"\n       ui-sref-active=\"active\" ga-track-event=\"['My Catalog', 'Click', '{{ type.label | translate | escapeSingleQuote }}']\">\n       {{ type.label | translate }}\n    </a>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vehicle/catalog/components/catalog-navbar/catalog-navbar.html
// module id = 1071
// module chunks = 0